// extracted by mini-css-extract-plugin
export default {"li":"styles_li__cy1uj"};